import { Draft, PayloadAction } from '@reduxjs/toolkit';
import EUserType from 'enums/userTypes';

import { IAuthData } from '../../initialState';

export interface IAccountEditRequestAction {
  data: {
    email: string;
    firstName: string;
    fixPhoneNumber?: string;
    gsm: string;
    id: number;
    intervention_partnership_id: number;
    lastName: string;
    locale: string;
    password?: string;
    role?: EUserType;
  };
  functions: {
    error: (err: any) => void;
    success: () => void;
  };
}

function editRequest(
  draft: Draft<IAuthData>,
  _: PayloadAction<IAccountEditRequestAction>,
) {
  draft.edit.config.isLoading = true;
}

export default editRequest;
